@use '../../../../styles/scss/global/mixins/rtl';

vs-wechat-share {
  button.vs-wechat-btn {
    margin: 15px;
    text-decoration: none;
    background: none;
    border: none;
    padding: 0px;
    cursor: pointer;

    &[data-button-size='small'] {
      font-size: 24px;
      line-height: 100%;
    }

    &[data-button-size='medium'] {
      font-size: 32px;
      line-height: 100%;
    }

    &[data-button-size='large'] {
      font-size: 40px;
      line-height: 100%;
    }

    &[data-button-color='default'] {
      color: rgb(68, 161, 114);
    }

    &[data-button-color='black'] {
      color: rgb(0, 0, 0);
    }

    &[data-button-color='primary'] {
      color: #1434cb;

      &:hover,
      &:focus {
        color: #021e4c;
      }

      &:focus {
        outline: 1px dashed black;
        outline-offset: 2px;
      }
    }
  }

  .vs-hide-wechat-modal {
    opacity: 0;
    display: none;
    pointer-events: none;
  }

  .vs-wechat-modal-wrapper {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 30;
    transition: opacity 0.3s ease;
  }

  .vs-wechat-share-modal {
    padding: 48px;
    width: 300px;
    max-width: 80vh;
    display: inline-block;
    background-color: #ffffff;
    text-align: center;
    position: relative;
  }

  .visa-icon-close {
    font-size: 24px;
    background: none;
    border: none;
    color: #5c5c5c;
    cursor: pointer;

    &:hover {
      color: #2c2c2c;
    }

    &:focus {
      color: #2c2c2c;
      outline: 1px dashed black;
      outline-offset: 2px;
    }
  }

  .vs-wechat-canvas {
    height: 125px;
    width: 125px;
  }

  .vs-wechat-header-text {
    text-transform: none;
    margin-bottom: 18px;
  }

  .vs-wechat-close {
    position: absolute;
    top: 10px;
    right: 10px;

    @include rtl.rtl {
      right: unset;
      left: 10px;
    }
  }
}
